export const ROLE_LABELS = {
  member: 'Member',
  moderator: 'Moderator',
  minecraft_moderator: 'Minecraft Moderator',
  apparel_manager: 'TOA Apparel Manager',
  marketer: 'Marketer',
  admin: 'Administrator',
};

export function dashboardSectionsForRole(role) {
  switch (String(role || '').toLowerCase()) {
    case 'admin': return ['overview','news','applications','commerce-minecraft','commerce-apparel','staff','members'];
    case 'minecraft_moderator': return ['applications'];
    case 'moderator': return ['applications'];
    case 'apparel_manager':
    case 'marketer': return ['commerce-apparel'];
    default: return [];
  }
}

export function canAccessDashboard(role) { return dashboardSectionsForRole(role).length > 0; }
